<div class="encounter-drawer-content">
  <div class="selected-date">
    <mat-radio-group
      aria-label="Select an option"
      class="radio-color"
      [(ngModel)]="radioSelected"
      (change)="patientChange()"
    >
      <mat-radio-button [value]="mrn" *ngFor="let mrn of allPatient">
        {{ mrn.mar }}
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <div class="mt-10">
    <table class="table-drawer-encounter">
      <tbody>
        <tr>
          <td class="center" rowspan="4" style="background-color: white">
            <img
              class="encounter-img"
              src="./assets/images/user.png"
              *ngIf="!details.photo"
            />
            <img
              class="encounter-img"
              [src]="details.photo"
              *ngIf="details.photo"
            />
          </td>
        </tr>
        <tr>
          <td>
            {{ "AppointmentPage.name" | translate }} <b> {{ details?.name }}</b>
          </td>
        </tr>
        <tr>
          <td>
            TRN/MRN <b>{{ details?.mrnNumber }}</b>
          </td>
        </tr>
        <tr>
          <td>{{ details?.gender }} / 35Yr</td>
        </tr>
        <tr>
          <td>
            <mat-icon class="icon-drawer">insert_invitation</mat-icon>
            {{ "AppointmentListPage.appointmentNo" | translate }}
          </td>
          <td>{{ details?.appno }}</td>
        </tr>
        <tr>
          <td>
            <mat-icon class="icon-drawer">insert_invitation</mat-icon>
            {{ "AppointmentListPage.appointmentNo" | translate }}
          </td>
          <td>{{ details?.id }} /{{ details?.idno }}</td>
        </tr>
        <tr>
          <td>
            <mat-icon class="icon-drawer">video_label</mat-icon>
            {{ "AppointmentPage.specialty" | translate }}
          </td>
          <td>{{ details?.department }}</td>
        </tr>
        <tr>
          <td>
            <mat-icon class="icon-drawer">supervised_user_circle</mat-icon>
            {{ "AppointmentListPage.doctor" | translate }}
          </td>
          <td>{{ details?.doctor }}</td>
        </tr>
        <tr>
          <td>
            <mat-icon class="icon-drawer">calendar_today</mat-icon>
            {{ "AppointmentPage.appointmentdate" | translate }}
          </td>
          <td>
            {{ details?.appointment | date: "dd/MM/yyyy hh:mm aa" }}
          </td>
        </tr>

        <tr>
          <td>
            <mat-icon class="icon-drawer">navigation</mat-icon>
            {{ "EncounterPage.mobile" | translate }}
          </td>
          <td>{{ details?.mobile }}</td>
        </tr>
        <tr>
          <td>
            <mat-icon class="icon-drawer">streetview</mat-icon>
            {{ "RegistrationPage.emailID" | translate }}
          </td>
          <td>{{ details?.email }}</td>
        </tr>
        <tr>
          <td>
            <mat-icon class="icon-drawer">personal_video</mat-icon>
            {{ "AppointmentPage.referencedoctor" | translate }}
          </td>
          <td>{{ details?.ref }}</td>
        </tr>
        <tr>
          <td>
            <mat-icon class="icon-drawer">room_service</mat-icon>
            {{ "EncounterListPage.reference" | translate }}
          </td>
          <td>{{ details?.refType }}</td>
        </tr>
        <tr>
          <td>
            <mat-icon class="icon-drawer">query_builder</mat-icon>
            {{ "AppointmentPage.bookingtype" | translate }}
          </td>
          <td>
            {{ details?.bookingType }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="center mt-20">
    <button class="btn-enc-action">
      {{ "AppointmentListPage.cancelAppointment" | translate }}
    </button>
    <button class="btn-enc-action">
      {{ "AppointmentListPage.rescheduleAppointment" | translate }}
    </button>

    <button class="btn-enc-action">
      {{ "AppointmentListPage.print" | translate }}
    </button>
  </div>
</div>
